import { render } from "./VideoPlayer.vue?vue&type=template&id=c898a3c8"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Product/Gallery/VideoPlayer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c898a3c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c898a3c8', __exports__)) {
    api.reload('c898a3c8', __exports__)
  }
  
  module.hot.accept("./VideoPlayer.vue?vue&type=template&id=c898a3c8", () => {
    api.rerender('c898a3c8', render)
  })

}


export default __exports__